import axiosInstance from './axiosInstance';

const prayerCenterService = {
  // Standalone endpoints (new page)
  listAll: (params = {}) =>
    axiosInstance.get('/admin/prayer-centers', { params }),

  create: (data) =>
    axiosInstance.post('/admin/prayer-centers', data),

  update: (id, data) =>
    axiosInstance.put(`/admin/prayer-centers/${id}`, data),

  remove: (id) =>
    axiosInstance.delete(`/admin/prayer-centers/${id}`),

  // Nested under representation (used in RepresentationsPage)
  listByRepresentation: (representationId) =>
    axiosInstance.get(`/admin/representations/${representationId}/prayer-centers`),

  sync: (representationId, centers) =>
    axiosInstance.post(`/admin/representations/${representationId}/prayer-centers/sync`, { centers }),
};

export default prayerCenterService;
